import { registerModule } from '../../core/module.js';
import { GiftCards } from './GiftCards.js';

/** Selling gift cards, and what is still owed on the ones already sold. */
export default registerModule({
  id: 'giftcards',
  order: 45,
  nav: [
    {
      to: '/gift-cards',
      labelKey: 'nav.giftCards',
      icon: '🎁',
      group: 'money',
      permission: 'giftcard.view',
      order: 4,
      hintKey: 'nav.hintGiftCards',
    },
  ],
  routes: [
    { path: '/gift-cards', element: <GiftCards />, permission: 'giftcard.view', titleKey: 'gift.title' },
  ],
});
